/**
 * Klapt de filterkolom op de collectiepagina in en uit (zoals de "Filter <"-knop in het vorige thema).
 */
class MmFilterToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.#toggle);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.#toggle);
  }

  #toggle = () => {
    const wrapper = this.closest('.collection-wrapper');
    if (!wrapper) return;
    const hidden = wrapper.toggleAttribute('data-mm-filters-hidden');
    this.button?.setAttribute('aria-expanded', String(!hidden));
  };
}

if (!customElements.get('mm-filter-toggle')) {
  customElements.define('mm-filter-toggle', MmFilterToggle);
}
